module.exports = __webpack_public_path__ + "static/img/7.5b5ccb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu_shenfree/7.png
// module id = 0o9+
// module chunks = 0